<template>
  <div class="container">
    <div class="find_wrap">
      <div class="tab_area">
        <div id="" class="">STEP 01. 비밀번호 찾기</div>
        <div id="" class="on">STEP 02. 비밀번호 변경하기</div>
      </div>
      <div class="find_form find_form_pw">
        <div class="find_title">
          라온 메타데미를 이용하기 위한 비밀번호를 변경해주세요.
        </div>

        <div class="form_area">
          <!-- <form action="/find_id_complete" id="find_and_change_pw" method="POST"
            onsubmit="return formCheckFindPwChange(this)"> -->
          <form id="find_and_change_pw" @submit.prevent="changePwChk()">
            <div class="find_form_inner find_form_info">
              <table class="table_style_1">
                <tbody>
                  <tr>
                    <th>아이디</th>
                    <td>
                      <input
                        id="user_id"
                        v-model="userId"
                        type="text"
                        name=""
                        readonly
                      />
                    </td>
                  </tr>
                  <tr>
                    <th><span>*</span>새 비밀번호</th>
                    <td>
                      <input
                        id="user_pw"
                        v-model="newPW"
                        type="password"
                        name=""
                        placeholder="비밀번호 입력해주세요."
                      />
                    </td>
                  </tr>
                  <tr>
                    <th><span>*</span>새 비밀번호 확인</th>
                    <td>
                      <input
                        id="user_pw_ok"
                        v-model="newPWChk"
                        type="password"
                        name=""
                        placeholder="비밀번호를 다시 입력해주세요."
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="btn_area">
                <a href="/login" class="btn_orange btn_cancel">취소</a>
                <input
                  type="button"
                  class="btn_orange"
                  value="비밀번호 변경하기"
                  @click="changePwChk()"
                />
              </div>
            </div>
          </form>
        </div>
        <div class="Modals">
          <ModalAlert
            :alert-msg="errMsg"
            :is-open="errStatus"
            :pw-c-page="pwCahngePage"
            :change-sucess="changeSucess"
            :approach="approach"
            @update:is-open="updateStatus"
          ></ModalAlert>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { changePWPage, changePW } from '../api/find'
import ModalAlert from '../components/ModalAlert.vue'
// import { useRouter } from 'vue-router';

export default {
  name: 'FindPWChangeViews',
  components: {
    ModalAlert,
  },
  setup() {
    // const router = useRouter();

    const url = new URL(window.location.href)
    const info = ref(url.searchParams.get('info'))
    const token = ref(url.searchParams.get('token'))

    const userId = ref('')

    const errMsg = ref('')
    const errStatus = ref(false)
    const pwCahngePage = ref('')
    const changeSucess = ref(false)
    const approach = ref(false)

    const userName = ref('')
    const newPW = ref('')
    const newPWChk = ref('')
    const sendData = async () => {
      try {
        const loadChangePage = await changePWPage(info.value, token.value)
        if (loadChangePage.code === 'MB22100200') {
          userId.value = loadChangePage.content.userid
        } else if (
          loadChangePage.code === 'MB22101400' ||
          loadChangePage.code === 'MB22101404' ||
          loadChangePage.code === 'MB22103404'
        ) {
          // 유효하지 않은 토큰 -> 복호화는 됐는데 시간 만료(400), 유효하지 않은 info -> 복호화 자체 불가능(404), 회원 정보 불일치(3404)
          errStatus.value = true
          approach.value = true
          errMsg.value = '잘못된 접근입니다. <br> 링크 재요청 후 접근해주세요.'
        }
      } catch (err) {
        // console.log(err);
      }
    }
    const changePwChk = async () => {
      pwCahngePage.value = 'pwChk'
      const letChangePW = await changePW(
        token.value,
        newPW.value,
        newPWChk.value
      )
      if (letChangePW.code === 'MB22202400') {
        errStatus.value = true
        errMsg.value =
          '비밀번호 조건이 유효하지 않습니다 <br> (숫자, 영어, 특수문자를 포함하여<br>8글자 이상, 20글자 이하로 설정하여 주세요)'
      } else if (letChangePW.code === 'MB22203400') {
        errStatus.value = true
        errMsg.value = '변경된 비밀번호가 일치하지 않습니다. 다시 확인해주세요.'
        // errMsg.value = "새 비밀번호 확인 값을 잘못 입력하셨습니다."
      } else if (letChangePW.code === 'MB22200200') {
        errStatus.value = true
        changeSucess.value = true
        errMsg.value = '비밀번호가 변경되었습니다.'
      } else if (letChangePW.code === 'MB22204400') {
        errStatus.value = true
        errMsg.value =
          '이전 비밀번호와 동일합니다.<br>새로운 비밀번호를 사용해주세요'
      } else if (letChangePW.code === 'MB22201400') {
        errStatus.value = true
        errMsg.value = '잘못된 접근입니다. <br> 링크 재요청 후 접근해주세요.'
      }
    }
    const updateStatus = () => {
      errStatus.value = false
    }

    onMounted(() => {
      sendData()
    })
    return {
      errMsg,
      errStatus,
      pwCahngePage,
      changeSucess,
      approach,

      userId,

      userName,
      newPW,
      newPWChk,

      sendData,
      changePwChk,
      updateStatus,
    }
  },
}
</script>
